// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'
var LineGroup = function (fields)
{
    PFixFieldSet.call(this, FieldsFactory.LINE_GROUP_NAME, null, fields)
}
LineGroup.prototype = Object.create(PFixFieldSet.prototype);

LineGroup.prototype.getContent = function ()
{
    return this.GetValue(FieldsFactory.FIELD_TEXT);
};
LineGroup.prototype.setContent = function (content)
{
    this.SetField(FieldsFactory.FIELD_TEXT, content);
};


LineGroup.prototype.getLineNum = function ()
{
    return this.GetValue(FieldsFactory.FIELD_LINE_NUMBER);
};
LineGroup.prototype.setLineNum = function (lineNumber)
{
    this.SetField(FieldsFactory.FIELD_LINE_NUMBER, lineNumber);
};

LineGroup.MAX_LENGTH = 10000;

LineGroup.setLongText = function (text)
{
    var groups = [];
    var number = 0;
    var index = 0;
    var length = text.length;
    while (index < length)
    {
        var len = Math.min(length - index, this.MAX_LENGTH);
        var curString = text.substring(index, index + len);

        index += len;

        var group = new LineGroup();
        group.setContent(curString);
        group.setLineNum(number);
        groups[number] = group;

        number += 1;
    }

    return groups;
};

LineGroup.CompareTo = function (a, b)
{
    var an = a.getLineNum()
    var bn = b.getLineNum();
    if (an < bn)
        return -1;
    else if (an > bn)
        return 1;
    else
        return 0;
};

LineGroup.getLongText = function (fieldSet)
{
    var groups = fieldSet.GetGroups(FieldsFactory.LINE_GROUP_NAME);
    var lines = [];

    var i;
    var count = groups.length;
    for (i = 0; i < count; i++)
        lines[i] = new LineGroup(groups[i]);

    lines.sort(this.CompareTo);

    var sb = "";
    for (i = 0; i < count; i++)
        sb += lines[i].getContent();

    return sb;
};

export { LineGroup }